import { createRouter, createWebHistory } from "vue-router";
import { getOrganizationSchema } from "@/seo/schema";

import Home from "../views/Home.vue";
import Contact from "../views/Contact.vue";
import LegalMention from "../views/LegalMention.vue";
import Layout from "../views/Layout.vue";

import QuiSommeNous from "../views/about/QuiSommeNous.vue";
import OrganisationFonctionnement from "../views/about/OrganisationFonctionnement.vue";
import ApprocheValeurs from "../views/about/ApprocheValeurs.vue";
import PartenairesReseau from "../views/about/PartenairesReseau.vue";
import ZoneIntervention from "../views/about/ZoneIntervention.vue";

const routes = [
  {
    path: "/",
    name: "public",
    component: Layout,
    children: [
      { path: "/", name: "Home", component: Home },
      {
        path: "/accompagnement-palliatif",
        name: "AccompPalliatif",
        component: () => import("@/views/services/AccompPalliatif.vue"),
      },
      {
        path: "/situations-complexes-urgences",
        name: "SituationsComplexesUrgences",
        component: () =>
          import("@/views/services/SituationsComplexesUrgences.vue"),
      },
      {
        path: "/soins-bien-etre-socio-esthetique",
        name: "SoinsBienEtreSocioEsthetique",
        component: () =>
          import("@/views/services/SoinsBienEtreSocioEsthetique.vue"),
      },
      {
        path: "/personnes-agees-troubles-cognitifs",
        name: "PersonnesAgeesTroublesCognitifs",
        component: () =>
          import("@/views/services/PersonnesAgeesTroublesCognitifs.vue"),
      },
      {
        path: "/adultes-perte-autonomie-situation-handicap",
        name: "AdultesPerteAutonomieSituationHandicap",
        component: () =>
          import("@/views/services/AdultesPerteAutonomieSituationHandicap.vue"),
      },
      {
        path: "/enfants-et-adolescents",
        name: "EnfantsEtAdolescents",
        component: () => import("@/views/services/EnfantsEtAdolescents.vue"),
      },
      {
        path: "/accompagnement-en-institutions",
        name: "AccompagnementInstitutions",
        component: () =>
          import("@/views/services/AccompagnementInstitutions.vue"),
      },
      {
        path: "/voyages-et-residences-secondaires",
        name: "VoyagesResidencesSecondaires",
        component: () =>
          import("@/views/services/VoyagesResidencesSecondaires.vue"),
      },
      {
        path: "/mise-au-lit-tardive",
        name: "MiseAuLit",
        component: () => import("@/views/services/MiseAuLit.vue"),
      },

      {
        path: "/qui-sommes-nous",
        name: "QuiSommeNous",
        component: QuiSommeNous,
      },
      {
        path: "/organisation-fonctionnement",
        name: "OrganisationFonctionnement",
        component: OrganisationFonctionnement,
      },
      {
        path: "/approche-valeurs",
        name: "ApprocheValeurs",
        component: ApprocheValeurs,
      },
      {
        path: "/partenaires-reseau",
        name: "PartenairesReseau",
        component: PartenairesReseau,
      },
      {
        path: "/zone-intervention",
        name: "ZoneIntervention",
        component: ZoneIntervention,
      },
      {
        path: "/galerie",
        name: "Gallery",
        component: () => import("@/views/Gallery.vue"),
      },
      { path: "/contact", name: "contact", component: Contact },
      {
        path: "/mention-legal",
        name: "LegalMention",
        component: () => import("@/views/LegalMention.vue"),
      },
      { path: "/:pathMatch(.*)*", redirect: "/" },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0, behavior: "instant" };
    }
  },
});

router.afterEach(() => {
  // Supprimer l'ancien schema s'il existe
  const old = document.getElementById("schema-org");
  if (old) old.remove();

  // Créer le script JSON-LD
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = "schema-org";
  script.text = JSON.stringify(getOrganizationSchema());

  document.head.appendChild(script);
});

export default router;
